
export function parseIntNumber(input) {
    let parsed = parseInt(input);
    if (typeof parsed !== "number" || isNaN(parsed)) {
        parsed = 0;
    }
    return parsed;
}